import { useState } from 'preact/hooks';
import { useLocation } from 'wouter-preact';
import { Field } from '../ui/Field.jsx';
import { Sheet } from '../ui/Sheet.jsx';
import { useDb } from '../contexts.jsx';
import { searchFamilies } from '../store/selectors.js';

export function Search() {
  const { db } = useDb();
  const [, navigate] = useLocation();
  const [q, setQ] = useState('');
  const [hits, setHits] = useState([]);
  async function onInput(e) {
    const v = e.currentTarget.value;
    setQ(v);
    setHits(v.length >= 2 ? await searchFamilies(db, v) : []);
  }
  return (
    <>
      <Field label="Search name / phone / address">
        <input autoFocus value={q} onInput={onInput} />
      </Field>
      {hits.map(({ family, matchedPerson }) => (
        <div
          key={family.family_key}
          onClick={() => navigate(`/family/${encodeURIComponent(family.family_key)}`)}
          style={{ cursor: 'pointer' }}
        >
          <Sheet>
            <div style={{ fontWeight: 600 }}>{family.name}</div>
            <div style={{ color: 'var(--muted)', fontSize: 13 }}>
              {family.address}
              {family.mandal ? ` · ${family.mandal}` : ''}
            </div>
            {matchedPerson && <div style={{ fontSize: 13 }}>matched: {matchedPerson.name}</div>}
          </Sheet>
        </div>
      ))}
    </>
  );
}
